import { render, staticRenderFns } from "./IconDoc.vue?vue&type=template&id=43a75ce8&"
import script from "./IconDoc.vue?vue&type=script&lang=ts&"
export * from "./IconDoc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports